'use strict';

// load lib like Google Analytics ...
require('mandant/3rdPartyLibs').load();

var dependencies = [
  'gettext',
  'ngAnimate',
  'ngRoute',
  'ngSanitize',
  'ngMessages',
  'ngclipboard',
  'ngCookies',
  'credit-cards',
  'mm.iban',
  require('./common/commonModule').name,
  require('./modules/account/accountModule').name,
  require('./modules/calendar/calendarModule').name,
  require('./modules/course/courseModule').name,
  require('./modules/customer/customerModule').name,
  require('./modules/booking/bookingModule').name,
  require('./modules/customFields/customFieldsModule').name,
  require('./modules/export/exportModule').name,
  require('./modules/fbWidget/fbWidgetModule').name,
  require('./modules/googleSync/googleSyncModule').name,
  require('./modules/calendars-sync/calendarsSyncModule').name,
  require('./modules/holidays/holidaysModule').name,
  require('./modules/mailTemplate/mailTemplateModule').name,
  require('./modules/message/messageModule').name,
  require('./modules/openingHours/openingHoursModule').name,
  require('./modules/pageWidget/pageWidgetModule').name,
  require('./modules/payment/paymentModule').name,
  require('./modules/profile/profileModule').name,
  require('./modules/resources/resourcesModule').name,
  require('./modules/service/serviceModule').name,
  require('./modules/settings/settingsModule').name,
  require('./modules/shiftPlanning/shiftPlanningModule').name,
  require('./modules/sms/SMSModule').name,
  require('./modules/statistic/statisticModule').name,
  require('./modules/user/userModule').name,
  require('mandant/modules').name,
  'ngIntercom',
  'ui.bootstrap',
  'ui.router',
  'ui.select',
  'ui.grid',
  'ui.grid.selection',
];

var t2gApp = angular.module('t2g', dependencies);

t2gApp.config(function(
  $httpProvider,
  $stateProvider,
  $urlRouterProvider,
  $urlServiceProvider,
  uiSelectConfig,
  $intercomProvider,
  $compileProvider,
  settings,
  $locationProvider,
) {
  uiSelectConfig.resetSearchInput = true;
  uiSelectConfig.appendToBody = true;

  $locationProvider.hashPrefix('');
  $urlServiceProvider.config.strictMode(false);

  $urlRouterProvider.otherwise('/private/main');

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|webcal):/);

  $stateProvider
    .state('private', {
      url: '/private',
      abstract: true,
      template: '<div class="inner-view-container" ui-view></div>',
      resolve: {
        session: function(UserSessionDA) {
          return UserSessionDA.ping();
        },
        subscription: function(SubscriptionDA, SubscriptionState) {
          return SubscriptionDA.get().then(function(response) {
            if (response.trialDaysLeft === 0) {
              SubscriptionState.setShouldSubscribe(true);
            }

            return response;
          });
        },
      },
    })
    .state('private.main', {
      url: '/main',
      controller: 'MainCtrl',
      templateUrl: 'app/PrivateView.html?v=4.5.6',
      resolve: {
        officeResolve: function(OfficeDA) {
          return OfficeDA.get();
        },
        industryResolve: function(Industry) {
          return Industry.query({}).$promise;
        },
        countryResolve: function(CountryConfig) {
          return CountryConfig.getCountries();
        },
        resourceResolve: function($q, ObjectModel) {
          var deffered = $q.defer();

          ObjectModel.get(function(error, response) {
            if (error) {
              deffered.reject(error);
            } else {
              deffered.resolve(response);
            }
          });

          return deffered.promise;
        },
        industrySpecificResolve: function(IndustrySpecific) {
          return IndustrySpecific.getLabels();
        },
        customers: function(CustomerDA) {
          return CustomerDA.list();
        },
      },
    });

  // disable json cache in IE
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }

  $httpProvider.interceptors.push(function($q, $window, UserSession, settings) {
    /**
     * Redirect to login page with current URL as next parameter
     * Prevents multiple simultaneous redirects
     */
    function redirectToLogin() {
      if ($window.__redirectingToLogin) return;
      $window.__redirectingToLogin = true;

      const next = encodeURIComponent($window.location.href);
      // Use the configured login_url from settings and append the next parameter
      const loginUrl = settings.login_url;
      $window.location.assign(`${loginUrl}?next=${next}`);
    }

    return {
      request: function(config) {
        return config || $q.when(config);
      },
      requestError: function(rejection) {
        return $q.reject(rejection);
      },
      response: function(response) {
        return response || $q.when(response);
      },
      responseError: function(rejection) {
        if (rejection.status === 401) {
          redirectToLogin();
          return $q.reject(rejection); // Still reject to stop the promise chain
        }

        return $q.reject(rejection);
      },
    };
  });

  $intercomProvider.appID(settings.INTERCOM_APP_ID);
  $intercomProvider.asyncLoading(true);
});

t2gApp.run(function(
  $anchorScroll,
  $location,
  $rootScope,
  $trace,
  $state,
  $window,
  $transitions,
  gettextCatalog,
  LocalStorage,
  settings,
  uibDatepickerPopupConfig,
  languageSwitch,
  $intercom,
  SubscriptionState,
) {
  languageSwitch.init().then(function() {
    uibDatepickerPopupConfig.closeText = gettextCatalog.getString('Close');
    uibDatepickerPopupConfig.currentText = gettextCatalog.getString('Today');
  });

  $rootScope.mandant = settings.mandant;

  $transitions.onStart({}, function() {
    $rootScope.isViewLoading = true;
    $window.ga && $window.ga('send', 'pageview', $location.path());
    $anchorScroll();
    NProgress.start();
  });

  $transitions.onSuccess({}, function(transition) {
    var toState = transition.to().name;
    var fromState = transition.from().name;

    $rootScope.isViewLoading = false;
    NProgress.done();

    if (fromState === 'private.main.customerProfile') {
      LocalStorage.remove('openAppointment');
    }

    if (toState === 'private.main') {
      $state.go('private.main.calendar');
    }

    $rootScope.currentState = toState.replace('private.main.', '');
  });

  $transitions.onError({}, function(transition) {
    console.error(transition.error());
  });

  if (settings.INTERCOM_APP_ID) {
    var user = LocalStorage.get('UserSession');
    var intercomSettings = {
      alignment: 'left',
      horizontal_padding: 9,
    };

    if (user) {
      intercomSettings.email = user.email;
      intercomSettings.name = user.firstname + ' ' + user.lastname;
      intercomSettings.user_hash = user.user_hash;
    }

    $intercom.boot(intercomSettings);
  }
});

t2gApp.controller('MainCtrl', function(
  $location,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $window,
  $uibModal,
  $cookies,
  AppointmentDA,
  AppointmentModel,
  Booking,
  BookingDA,
  CalendarDA,
  ModalService,
  countryResolve,
  CustomerModel,
  gettextCatalog,
  industryResolve,
  IndustrySpecific,
  industrySpecificResolve,
  io,
  Message,
  Notification,
  OfficeModel,
  officeResolve,
  resourceResolve,
  UserSession,
  settings,
  subscription,
) {
  $scope.industries = industryResolve;
  $scope.office = officeResolve;
  $scope.countries = countryResolve;
  $scope.isViewLoading = false;
  $scope.uncheckedSteps = 4;
  $scope.showFirstSteps = false;
  $scope.currentUser = UserSession.get();
  $scope.unprocessedMessages = 0;
  $scope.bookings = [];
  $scope.loadingAccept = false;
  $scope.loadingDecline = false;
  $scope.showOverlay = false;
  $scope.showValidation = false;
  $scope.overlayLoading = false;
  $scope.showChoosePricemodel = false;
  $scope.showBooking = false; // hide booking info alert
  $scope.bookingMinimized = false;
  $scope.subscription = subscription;
  $scope.labels = {
    customer: gettextCatalog.getString(industrySpecificResolve.customer.toLowerCase()),
    customers: gettextCatalog.getString(industrySpecificResolve.customers.toLowerCase()),
  };

  if (settings.showUserlane && window.Userlane) {
    // initialize Userlane
    window.Userlane('init', settings.USERLANE_APP_ID);

    if ($scope.currentUser._id) {
      // identify the current user
      window.Userlane('user', $scope.currentUser._id);
    }
  }

  var allowedRoles = {
    admin: ['admin'],
    manager: ['admin', 'manager'],
    employee: ['admin', 'manager', 'employee'],
    viewer: ['admin', 'manager', 'employee', 'viewer'],
  };

  if (
    angular.isDefined($scope.office.settings.acceptBooking) &&
    $scope.office.settings.acceptBooking === 0
  ) {
    $scope.showBooking = false;
  }

  // load industry specific labels
  var loadLabels = function() {
    IndustrySpecific.getLabels().then(function(labels) {
      $scope.labels.customer = gettextCatalog.getString(labels.customer);
      $scope.labels.customers = gettextCatalog.getString(labels.customers);
    });
  };

  var setNotProcessedBookingsCount = function() {
    var notProcessedBookings = $scope.bookings.filter(function(booking) {
      return !booking.processed;
    });

    $scope.$broadcast('updateBookingsBadge', notProcessedBookings.length);
  };

  $scope.$on('setBookingsProcessed', function() {
    $scope.bookings.forEach(function(booking) {
      booking.processed = true;
    });

    setNotProcessedBookingsCount();
  });

  var loadBookings = function() {
    BookingDA.getAll().then(function(bookingResponse) {
      $scope.bookings = bookingResponse.bookings || []; // all office bookings for all period of time (including declined)

      setNotProcessedBookingsCount();

      var declineBookingId = $cookies.get('declineBookingId');

      if (!declineBookingId) return; // do nothing if declineBookingId is not set in the cookies

      var declineBooking =
        declineBookingId &&
        $scope.bookings.filter(function(booking) {
          return booking._id === declineBookingId;
        })[0];

      if (!declineBooking) {
        // clear bookingId from cookies if it not exists
        $cookies.remove('declineBookingId');

        return Notification.addErrorMessage(gettextCatalog.getString('This booking is not exists'));
      }

      $scope.openRelatedAppointment(declineBooking);
    });
  };

  $scope.startDeclineBooking = function(declineBooking, openedAppointmentModal) {
    var openAppointment = _.get(declineBooking, 'appointments[0]');

    if (declineBooking.declined || !openAppointment) {
      // clear bookingId from cookies if it was already declined
      $cookies.remove('declineBookingId');

      return Notification.addErrorMessage(
        gettextCatalog.getString('This booking has already been declined'),
      );
    }

    var appointmentDate = moment(openAppointment.start).format('YYYY-MM-DD');

    if ($stateParams.date !== appointmentDate && !openedAppointmentModal) {
      $state.go('private.main.calendar', {
        date: appointmentDate,
      });
    }

    var appointmentModal =
      openedAppointmentModal || ModalService.openAppointmentModal(openAppointment);

    // declined booking should be first in the list
    $scope.bookings.sort(function(a, b) {
      if (a === declineBooking) return -1;
      if (b === declineBooking) return 1;

      return new Date(b.bookedAt) - new Date(a.bookedAt);
    });

    $scope.askDeclineReason().then(function(isConfirmPresses) {
      // clear bookingId from cookies on any user action
      $cookies.remove('declineBookingId');

      if (!isConfirmPresses) return;

      CalendarDA.removeAppointment(openAppointment._id);
      appointmentModal.close();

      loadBookings();
    });
  };

  $scope.openRelatedAppointment = function(declineBooking) {
    var openAppointment = _.get(declineBooking, 'appointments[0]');

    if (declineBooking.declined || !openAppointment) {
      // clear bookingId from cookies if it was already declined
      $cookies.remove('declineBookingId');

      return Notification.addErrorMessage(
        gettextCatalog.getString('This booking has already been declined'),
      );
    }

    var appointmentDate = moment(openAppointment.start).format('YYYY-MM-DD');

    if ($stateParams.date !== appointmentDate) {
      $state.go('private.main.calendar', {
        date: appointmentDate,
      });
    }

    var appointmentModal = ModalService.openAppointmentModal(openAppointment);

    appointmentModal.closed.then(function() {
      // clear bookingId from cookies on appointment edit pop up close
      $cookies.remove('declineBookingId');
    });
  };

  // check if name, industry and country code are filled. If not, show overlay
  if (
    !$scope.office.name ||
    !$scope.office.profile.industry ||
    !$scope.office.address.countryCode
  ) {
    $scope.showOverlay = true;
  } else {
    $scope.showOverlay = false;
  }

  // save overlay form (office name, industry and country ...) to database
  $scope.saveOverlayForm = function() {
    $scope.showValidation = true;
    $scope.overlayLoading = true;

    if ($scope.OverlayForm.$valid) {
      OfficeModel.update($scope.office, function(error) {
        if (error) {
          Notification.addErrorMessage({ text: error });
        } else {
          loadLabels();
          $scope.overlayLoading = false;
          $scope.showOverlay = false;
          $state.go('private.main.firstSteps');
          Notification.addSuccessMessage(gettextCatalog.getString('Saved successfully'));
        }
      });
    } else {
      $scope.overlayLoading = false;
    }
  };

  // UserLike stuff
  $window.userlike = {
    nostate: false,
  };

  $window.userlikeData = {};

  if ($scope.currentUser._id) {
    $scope.user = UserSession.get();

    // set UserLike data
    $window.userlikeData = {
      user: {
        name: $scope.currentUser.firstname + ' ' + $scope.currentUser.lastname,
        email: $scope.currentUser.email,
      },
      custom: {
        nutzerId: $scope.currentUser._id,
        dienstleisterId: $scope.office._id,
        dienstleister: $scope.office.name,
        branche: $scope.office.profile.industry,
        profil: 'https://www.termin2go.com/termin/unbekannt/unbekannt/' + $scope.office.slug,
        email: $scope.office.profile.contacts.email,
        tel: $scope.office.profile.contacts.phone,
        account: $scope.office.billing.account,
      },
    };

    if ($window.userlikeUpdateAPI) {
      $window.userlikeUpdateAPI();
    }
  }

  $scope.checkRole = function(minimumRole) {
    var role = _.get($scope.user, 'role');
    var authorized = false;

    if (role && allowedRoles[minimumRole].indexOf(role) !== -1) {
      authorized = true;
    }

    return authorized;
  };

  $scope.disableClick = function() {
    return false;
  };

  /**
   * accept booking
   */
  $scope.accept = function() {
    var lastBooking = $scope.bookings[0];
    $scope.loadingAccept = true;

    BookingDA.accept(lastBooking)
      .then(function(response) {
        $scope.bookings.splice(0, 1);
        $scope.loadingAccept = false;
        Notification.addSuccessMessage(gettextCatalog.getString('Booking accepted'));
        CalendarDA.editAppointment(response.appointments);

        _.forEach(response.appointments, function(appointment) {
          if (appointment.customer && appointment.customer._id) {
            CustomerModel.updateCache(appointment.customer, function() {
              console.log('update cache: ' + appointment.customer._id);
            });
          }
        });
      })
      .catch(function(error) {
        $scope.loadingAccept = false;
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant accept booking (Error: {{error}})', { error: error }),
        );
        loadBookings();
      });
  };

  /**
   * confirm booking
   */
  $scope.confirm = function() {
    var lastBooking = $scope.bookings[0];
    $scope.loadingAccept = true;

    BookingDA.confirm(lastBooking)
      .then(function(response) {
        $scope.bookings.splice(0, 1);
        $scope.loadingAccept = false;
        CalendarDA.editAppointment(response.appointments);

        _.forEach(response.appointments, function(appointment) {
          if (appointment.customer && appointment.customer._id) {
            CustomerModel.updateCache(appointment.customer, function() {
              console.log('update cache: ' + appointment.customer._id);
            });
          }
        });
      })
      .catch(function(error) {
        $scope.loadingAccept = false;
        Notification.addErrorMessage(error);
        loadBookings();
      });
  };

  /**
   * decline the booking
   */
  $scope.decline = function(reasonText) {
    var lastBooking = $scope.bookings[0];
    $scope.loadingDecline = true;

    if (reasonText) {
      lastBooking.note = reasonText;
    }

    if (lastBooking.newWidget) {
      BookingDA.decline(lastBooking).then(
        function(response) {
          _.forEach(lastBooking.appointments, function(appointmentId) {
            CalendarDA.removeAppointment(appointmentId);
          });
          $scope.bookings.splice(0, 1);
          $scope.$broadcast('Booking:decline', response);
          Notification.addSuccessMessage(
            gettextCatalog.getString(
              'Please make sure that you always keep your appointments updated and that changes only occur in exceptional cases. Thank you.',
            ),
          );
          Notification.addSuccessMessage(
            gettextCatalog.getString('Your booking has been canceled and the client informed.'),
          );
          $scope.loadingDecline = false;
        },
        function() {
          $scope.loadingDecline = false;
          Notification.addErrorMessage(gettextCatalog.getString('Cant decline booking'));
        },
      );
    } else {
      var booking = new Booking(lastBooking);

      booking.$decline(
        {},
        function(response) {
          _.forEach(lastBooking.appointments, function(appointmentId) {
            CalendarDA.removeAppointment(appointmentId);
          });
          $scope.bookings.splice(0, 1);
          $scope.$broadcast('Booking:decline', response);
          Notification.addSuccessMessage(
            gettextCatalog.getString(
              'Please make sure that you always keep your appointments updated and that changes only occur in exceptional cases. Thank you.',
            ),
          );
          Notification.addSuccessMessage(
            gettextCatalog.getString('Your booking has been canceled and the client informed.'),
          );
          $scope.loadingDecline = false;
        },
        function() {
          $scope.loadingDecline = false;
          Notification.addErrorMessage(gettextCatalog.getString('Cant decline booking'));
        },
      );
    }
  };

  /**
   * reload bookings on update
   */
  $scope.$on('Booking:delete', function() {
    loadBookings();
  });

  /**
   * show decline pop up on related appointment remove try
   */
  $scope.$on('Booking:showDeclineModal', function(event, data) {
    var bookingToDecline = $scope.bookings.filter(function(booking) {
      return _.get(booking, 'appointments[0]._id') === data.appointmentId;
    })[0];

    $scope.startDeclineBooking(bookingToDecline, data.appointmentModal);
  });

  $scope.askDeclineReason = function() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/declineModal.html?v=4.5.6',
      controller: 'DeclineReasonModal',
      size: 'sm',
    });

    return modalInstance.result.then(
      function(reasonText) {
        $scope.decline(reasonText);

        return true;
      },
      function(dismiss) {
        return false;
      },
    );
  };

  /**
   * add new booking, if socket emit new booking
   */
  io.on('Booking:save', function(booking) {
    $scope.bookings.push(booking);

    setNotProcessedBookingsCount();

    $scope.$broadcast('Booking:save', booking);
  });

  /**
   * socket event. appointment will be added to scope if dates matches with current date
   */
  io.on('Appointment:save', function(appointments) {
    appointments = AppointmentDA.transformResponse(appointments);

    CalendarDA.insertAppointment(appointments);
  });

  /**
   * socket event. appointment will be updated on scope if dates matches with current date
   */
  io.on('Appointment:update', function(appointments) {
    appointments = AppointmentDA.transformResponse(appointments);

    CalendarDA.editAppointment(appointments);
  });

  /**
   * socket event. appointment will be deleted on scope if dates matches with current date
   */
  io.on('Appointment:delete', function(appointmentId) {
    CalendarDA.removeAppointment(appointmentId);
  });

  /**
   * remove event listeners
   */
  $scope.$on('$destroy', function() {
    io.off();
  });

  loadBookings();
});

Date.prototype.getDayKey = function() {
  var year = this.getFullYear();
  var month = this.getMonth() + 1;
  var day = this.getDate();

  return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
};

Array.prototype.move = function(old_index, new_index) {
  if (new_index >= this.length) {
    var k = new_index - this.length;
    while (k-- + 1) {
      this.push(undefined);
    }
  }
  this.splice(new_index, 0, this.splice(old_index, 1)[0]);
  return this;
};

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function(s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

t2gApp.controller('DeclineReasonModal', function($scope, $uibModalInstance) {
  $scope.isSubmitted = false;

  $scope.isDeclineReasonInvalid = function() {
    return !$scope.declineReason || $scope.declineReason.length < 5;
  };

  $scope.decline = function() {
    $scope.isSubmitted = true;

    if ($scope.isDeclineReasonInvalid()) return;

    $uibModalInstance.close($scope.declineReason);
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});



// WEBPACK FOOTER //
// ./src/app/app.js